const emojis = [
  '🌴',
  '🌴',
  '🎷',
  '🌼',
  '🌞',
  '🍄',
  '🌳',
  '🌲',
  '😀',
  '😍',
  '✨',
  '⚡',
  '💪',
  '😇',
  '🚀',
  '☀️',
  '🦋',
  '🌻',
  '💫',
  '🌈',
  '😻',
  '\u{1F389}', // 🎉
  '\u{1F451}', // 👑
]

export default emojis
